import { State } from "./types";

function getGifListIds() {
  return (state: State) => state.gifsOrder;
}

function getGif(id) {
  return (state: State) => state.gifsById[id];
}

function getZoomLevel() {
  return (state: State) => state.zoomLevel;
}

function getRating() {
  return (state: State) => state.rating;
}

function getFocusedGif() {
  return (state: State) => state.focusedGifId;
}

function getHasMore() {
  return (state: State) =>
    state.pagination.currentCount < state.pagination.totalCount;
}

function getError() {
  return (state: State) => state.error;
}

export {
  getGifListIds,
  getGif,
  getZoomLevel,
  getRating,
  getFocusedGif,
  getHasMore,
  getError
};
